<template>
  <div>
    <oil-cap
      title='Поставщики'
      :buttons="[{name:'создать Поставщика',route:'supplier-create'}]"
    />
    <v-divider class='my-2' />

    <oil-table
      :keys='keys'
      :items='importers'
      :paginate='count'
      @paginateAction='paginate'
    >
      <template v-slot:Status='{value}'>
        <v-chip color='success' v-text='value' />
      </template>
      <template v-slot:Id="{value}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs"
                   v-on="on" icon
                   @click.stop="rowClick(value)">
              <v-icon color="primary">
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>

      <template v-slot:DeleteId="{value}">
        <v-row>
          <v-col
            md="4"
            offset-md="4"
          >
            <oil-modal
              :value="value"
              tooltipMessage="УДАЛИТЬ"
              mdiIcon="mdi-delete"
              :accept="accept"
            />

          </v-col>
        </v-row>

      </template>
    </oil-table>
  </div>

</template>

<script>

import { coreApi } from '~/services/core'
import { comingSupplier } from '~/services/ComingSupplier'

export default {
  components: {
    OilCap: () => import('@/components/helper/oil.cap'),
    OilTable: () => import('@/components/helper/oil.table'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal'),

  },
  data: () => ({
    keys: [
      {
        text: 'Название',
        value: 'Name'
      },
      {
        text: 'ДОГОВОР',
        value: 'Contract'
      },
      {
        text: 'Адрес',
        value: 'Address'
      },
      {
        text: '',
        value: 'Id'
      },
      {
        text: '',
        value: 'DeleteId'
      }
    ],
    status: {
      active: 'Активный',
      notsigned: 'Неподписанный',
      special: 'Особый',
      inactive: 'Неактивный'
    },
    importers: [],
    count:{
      count:0
    }
  }),
  methods: {
    rowClick(Id) {
      this.$router.push(`/supplier-create/${Id}`)
    },
    async paginate(page) {
      const importers = await comingSupplier.paginate(page)
      const { count, dates } = importers.data
      this.count.count = count
      this.importers = dates?.map(importer => {
        return {
          Name: importer.Name,
          Contract: importer?.Contracts?.map(({ Number }) => Number).join(','),
          Address: importer.Address,
          Id: importer.Id,
          DeleteId: importer.Id
        }
      })
    },
    async accept(id) {
      const isDelete = await coreApi.delete(`suppler?id=${id}`)
      if (isDelete.data) {
        const product = this.importers.find(({ Id }) => Id === id)
        const index = this.importers.indexOf(product)
        this.importers.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: 'удачно удален'
        })
      }
    },
  },
  async created() {
    await this.paginate((this.currentPage - 1) * 10)
    // this.importers = importers.data?.map(importer => {
    //   return {
    //     Name: importer.Name,
    //     Contract: importer?.Contracts?.map(({ Number }) => Number).join(','),
    //     Address: importer.Address,
    //     Id: importer.Id,
    //     DeleteId: importer.Id
    //   }
    // })
  }
}
</script>
